import { getCurrentWX, getCurrentWindow } from "../utils/window";
import { doUrlForDefaultOpen } from "./default-open";
/** 区分B端小程序 */

var isEntMiniProgram = function isEntMiniProgram() {
  var _window, _window$location, _window2, _window2$location;

  return /from=miniprogram/.test((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.search) || /from=miniprogram_wedoc/.test((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.search);
};
/**
 * 小程序中打开文件的处理.
 */


export function doOpenUrlForMiniProgram(targetUrl, options) {
  var wxUrl = options.wxUrl,
      replace = options.replace,
      supportIFrame = options.supportIFrame;
  var wx = getCurrentWX(supportIFrame);
  var currentWindow = getCurrentWindow(supportIFrame); // B端小程序不支持wx.miniProgram的方式跳转，改为location.href方式先

  if (isEntMiniProgram()) {
    currentWindow.location.href = targetUrl;
    return;
  }

  if (!(wx !== null && wx !== void 0 && wx.miniProgram)) {
    doUrlForDefaultOpen(targetUrl, options);
    console.error('no miniProgram sdk'); // 后续逻辑都依赖 wx.miniProgram, 取不到这个, 就应该停止逻辑

    return;
  } // 目标openUrl, 如果有wxurl,需要优先使用wxurl, 如果没有使用targetUrl


  var targetOpenUrl = wxUrl !== null && wxUrl !== void 0 ? wxUrl : getUrlFromTargetUrl(targetUrl);

  if (replace) {
    wx.miniProgram.redirectTo({
      url: targetOpenUrl
    });
  } else {
    wx.miniProgram.navigateTo({
      url: targetOpenUrl
    });
  }
}

function getUrlFromTargetUrl(targetUrl) {
  // 如果打开的是详情页，就是 https://docs.qq.com/sheet/Dksdjfkjkjkj  这样子的，那么在小程序中需要打开 detail 容器
  if (/^https:\/\/docs\.qq\.com\/(sheet|doc|slide|form|pdf|file|mind|flowchart|rec|aio)\/(.*)$/.test(targetUrl)) {
    return "/pages/detail/detail?url=".concat(encodeURIComponent(targetUrl));
  } // 如果是其他页面，就打开通用 webview 容器装载


  return "/pages/webview/webview?url=".concat(encodeURIComponent(targetUrl));
}